import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API, EsimListQueryParams} from '@chekin/api';

function useFetchEsims({reservation_id}: EsimListQueryParams) {
  const result = useQuery({
    queryKey: [QUERY_CACHE_KEYS.esims, reservation_id],
    queryFn: () => API.upselling.getEsims(`reservation_id=${reservation_id}`),
    enabled: Boolean(reservation_id),
  });

  return result;
}

export {useFetchEsims};
